// extracted by mini-css-extract-plugin
module.exports = {"carouselWrapper":"Carousel_carouselWrapper__4aV_z","dots":"Carousel_dots__7TvfU"};